import Button from 'components/forms/Button'
import LeftRobotCard from 'components/cards/new/common/LeftRobotCard'
import useWindowSize from 'components/util/useWindowSize'
import Link from 'next/link'

const ForAuEnterprise = () => {
  const size = useWindowSize()
  return (
    <LeftRobotCard
      image={{
        alt: 'Robot arm pointing right',
        desktop: {
          dimensions: {
            height: 449,
            width: 500,
          },
          src: '/images/new/robot-arm-pointing-right-v3.png',
        },
        mobile: {
          dimensions: {
            height: 1122,
            width: 696,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '50%' : '100%'}
      imageStyle={{
        maxWidth: '100%',
        objectFit: 'cover',
      }}
    >
      <div className='d-flex flex-column flex-1 px-4 pt-lg-27 pt-8 pb-7 pe-lg-10 mt-lg-0 mt-n20'>
        <h1 className='fs-fluid-36-80 lh-105 fw-semibold mb-5'>
          Built for <span className='color-pink2'>Australian Enterprise</span>{' '}
          Needs
        </h1>
        <div className='fs-fluid-20-26 lh-140 fw-semibold'>
          Our solution enables you to offer a registered office and director
          service address—digitally managed and regulation-ready.
        </div>
        <Link
          className='align-self-lg-end w-full w-lg-auto mt-6'
          href={'/au/enterprise#konnect-form'}
        >
          <Button className='w-100'>Book a Demo</Button>
        </Link>
      </div>
    </LeftRobotCard>
  )
}

export default ForAuEnterprise
